<script>
import options from './FormCheckbox.options'
export default options
</script>

<template>

  <div class="kb-form-checkbox">

    <div class="Form__Element FormChoice">

      <input
        v-model="localValue"
        type="checkbox"
        :required="isRequired ? true : false"
        :name="fieldName"
        :id="fieldName"
        @change="formLink"
        class="FormChoice__Input FormChoice__Input--Checkbox"
      />

      <label v-if="isRichText" :for="fieldName" class="FormChoice__Label">        
        <div v-html="label + (isRequired ? '*': '')" class="kb-rich-text kb-rich-text__content"></div>
      </label>
      <label v-else :for="fieldName" class="FormChoice__Label">
        {{ label + (isRequired ? '*': '')}} 
      </label>
      

      <template v-if="tooltipText">
        <TooltipComponent :tooltipText="tooltipText" />
      </template>
      
    </div>

    <p
      class="kb-forms Form__Element__ValidationError"
      v-if="inputHasValidationErrors && isValidationError"
      aria-live="assertive"
      >
      {{ errorMessageLabel }}
    </p>
    
    <p
      class="kb-form__input-helptext kb-form__input-helptext--checkbox"
      v-if="helpMessageLabel"
    >
      {{ helpMessageLabel }}
    </p>

  </div>
</template>
